<template>
  <section class="section">
    <p class="has-text-weight-bold">👉 New: Upload a pdf file to read online with Bookman!</p>

    <b-message type="is-info" has-icon v-if="!isAuthenticated">
      <div>Authentication needed in order to upload an epub file</div>
      <a href="/#/signup">Create an account</a> or <a href="/#/signin">sign in</a>
    </b-message>

    <nav class="level">
      <div class="level-item has-text-centered">
        <div>
          <b-message type="is-warning" has-icon v-if="isAuthenticated && !canUploadPdf">
            You need to subscribe to upload a pdf.
          </b-message>
          <b-field>
            <b-upload
              v-model="dropFile"
              accept=".pdf"
              drag-drop
              type="is-secondary"
              :disabled="!canUploadPdf">
              <section class="section">
                <div class="content has-text-centered">
                  <p>
                    <b-icon
                      icon="upload"
                      size="is-large">
                    </b-icon>
                  </p>
                  <p>Drop your pdf file here or click to upload</p>
                </div>
              </section>
            </b-upload>
          </b-field>

          <div class="tags">
            <span class="tag is-primary" v-if="dropFile">
              {{ dropFile.name }}
              <button class="delete is-small" type="button" @click="deleteDropFile()"/>
            </span>
          </div>

          <button type="button" v-bind:class="{ 'is-loading': isLocalLoading }" class="button is-secondary" @click="uploadPdf" :disabled="!canUploadPdf">
              <span>Start reading!</span>
          </button>
          <p class="section" v-if="!isSubscribedUser">
            {{ canReadEbooksSentence }}
          </p>
        </div>
      </div>
    </nav>
  </section>
</template>

<script>
export default {
  name: 'uploadPdf',
  data: () => ({
    dropFile: null
  }),
  methods: {
    deleteDropFile () {
      this.dropFile = null
    },
    goToSubscription () {
      this.$router.push('/subscription')
    },
    async uploadPdf () {
      try {
        await this.$store.dispatch('uploadPdf', { file: this.dropFile })
        this.dropFile = null
        this.$router.push(`/pdf/${this.pdf.id}`)
      } catch (err) {
        console.error(err)
      }
    }
  },
  computed: {
    canReadEbooksSentence () {
      if (!this.isSubscribedUser) {
        if (this.$store.getters.getUserTicketsCount > 0) {
          return `You can still read ${this.$store.getters.getUserTicketsCount} ebooks.`
        }
        return `You can't start a new ebook.`
      }
    },
    canUploadPdf () {
      return this.$store.getters.getUserTicketsCount > 0 || this.isSubscribedUser
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    isLocalLoading () {
      const localLoading = this.$store.getters.isLocalLoading
      return localLoading.componentId === 'uploadPdf' && localLoading.active
    },
    isSubscribedUser () {
      return this.$store.getters.isSubscribedUser
    },
    pdf () {
      return this.$store.getters.getPdf
    }
  }
}
</script>

<style>

</style>
